import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import SchoolIcon from '@mui/icons-material/School';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import $ from 'jquery';
import { disciplineStyles } from "../../Assets/js/customStyles.js";

export default function StudentAnswerScriptList() {

    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/college/");
    }

    const tableRef = useRef(null);

    const [loading, setlodaing] = useState(false);
    const { http } = Api();

    const [getexamData, setExamData] = useState([]);
    const [examid, setExamIdData] = useState(false);
    const [disciplinedata, setDisciplineData] = useState([]);
    const [disciplineId, setDisciplineChange] = useState(false);
    const [courseNameData, setCourseNameData] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(false);
    const [selctedforcource, setselctedforcource] = useState(false);
    const [courseName, setCourseName] = useState(false);
    const [Name, setcompletename] = useState(false);
    const [courseData, setCourseData] = useState([]);

    const [attendanceData, setAttendanceData] = useState({

        total_present: 0,
        total_malpractice: 0,
        total_absent: 0,
        total_students: 0
    });

    const [bundilestatus, setBundilestatus] = useState([]);
    const [despatch, setDespatch] = useState(false);
    const [stat, setstat] = useState([]);




    /* CUSTOME DATA TABLE BEGAINS HERE */

    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total_count, setTotal] = useState(null);

    /* CUSTOME DATA TABLE ENDS HERE */



    useEffect(() => {
        const fetchExamData = async () => {
            try {
                const response = await http.get(`College/getExamsForAnswerscript`);
                setExamData(response.data.examinations);
            }
            catch (error) {
                if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
                    toast.error("No active exam found");
                }
                else {
                    toast.error(error.response.data.message);
                }
            }
        };

        fetchExamData();
    }, []);

    const handlExamChange = (selectedOption) => {

        setExamIdData(selectedOption.value);
        setDisciplineChange(false);
        setselctedforcource(false);
        setSelectedCourse(false);
        setCourseName(false);
        setAttendanceData({
            total_present: 0,
            total_malpractice: 0,
            total_absent: 0,
            total_students: 0
        })
        setCourseData([]);
        setDisciplineData([]);
        setstat([]);
        setCourseNameData([]);


    };

    useEffect(() => {

        const fetchDisciplineData = async (selectedExamId) => {
            try {
                const response = await http.get(`College/getCollegeDisciplinesForAnswerscript`, {
                    params: {
                        examid: selectedExamId
                    },
                });
                setDisciplineData(response.data.disciplines);

            } catch (error) {

                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);
                } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        };

        if (examid) {

            fetchDisciplineData(examid);
        }


    }, [examid])

    const handlDisciplineChange = async (selectedOption) => {


        setDisciplineChange(selectedOption.value);
        setselctedforcource(false);
        setSelectedCourse(false);
        setCourseName(false);

        setAttendanceData({
            total_present: 0,
            total_malpractice: 0,
            total_absent: 0,
            total_students: 0
        })

        setCourseData([]);


    };

    useEffect(() => {

        const fetchCourses = async (disciplineId) => {
            try {
                // API call to fetch courses based on selected discipline
                const response = await http.get(`College/getCollegeDisciplineCoursesForAnswerscript`, {
                    params: {

                        discipline_id: disciplineId,
                        examid: examid
                    },
                });

                setCourseNameData(response.data.courses);

            } catch (error) {

                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);
                } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        };

        if (disciplineId) {

            fetchCourses(disciplineId);
        }

    }, [disciplineId])

    const handilecoursechange = (selctedcoption) => {

        setSelectedCourse(selctedcoption.value);
        setCourseName(selctedcoption.label);
        setselctedforcource(selctedcoption)

        setCourseData([]);



    }



    useEffect(() => {

        const fetchStudentList = async (disciplineId, examId, courseId) => {

            try {
                const response = await http.get(`College/getStudentdetailsforAnswerscript`, {
                    params: {

                        discipline_id: disciplineId,
                        examid: examId,
                        course_id: courseId

                    },
                });

                setCourseData(response.data.result);


                setAttendanceData({
                    total_present: response.data.total_present,
                    total_malpractice: response.data.total_malpractice,
                    total_absent: response.data.total_absent,
                    total_students: response.data.total_students
                });

                // console.log("bundilestatus", response.data.despatch_details);

                setBundilestatus(response.data.despatch_details);

            } catch (error) {
                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);
                } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        };


        if (selectedCourse) {

            fetchStudentList(disciplineId, examid, selectedCourse);
        }


    }, [selectedCourse, despatch])


    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),

        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };


    // useEffect(() => {
    //     if (!loading && courseData.length > 0) {
    //         const table = $(tableRef.current).DataTable({
    //             destroy: true,
    //             paging: true,           // Enable pagination
    //             lengthChange: true,     // Show entries-per-page dropdown
    //             pageLength: 10,         // Default number of entries per page
    //             searching: true,
    //             ordering: true,
    //             info: true,
    //             autoWidth: false,
    //             responsive: true,
    //         });

    //         $('.dataTables_filter input').addClass('form-control form-control-sm');
    //         $('.dataTables_length select').addClass('form-select form-select-sm');

    //         return () => {
    //             table.destroy();
    //         };
    //     }
    // }, [courseData, loading]);

    const handleDispatchHistory = () => {
        navigate("/College/collegebundledespstat");
    }
    const handleDispatchAll = () => {

        http.post(`College/saveBundileFacingSheetStatus`, {

            id: parseInt(localStorage.getItem("id")),
            examid: examid,
            course_id: selectedCourse
        },
        ).then((response) => {
            if (response.data.status_code === "MSG2") {
                toast.success("Dispatched Successfully");
                setDespatch(true);
            }
        }).catch((error) => {
            toast.error("Failed to dispatch");
        })

    }

    useEffect(() => {

        const fetchBundleCourseList = async (disciplineId, examId) => {

            try {
                const response = await http.get(`College/getCollegeBundleDespatchedCourseList`, {
                    params: {

                        discipline_id: disciplineId ? disciplineId : undefined,
                        examid: examId


                    },
                });

                setcompletename(response.data.courses);

                setstat(response.data.statistics);

            } catch (error) {
                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);
                } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        };


        if (disciplineId || examid) {

            fetchBundleCourseList(disciplineId, examid);
        }


    }, [disciplineId, examid])


    /* CUSTOME DATA TABLE BEGAINS HERE */

    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSort = (column) => {
        const newSortBy = {
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        };
        setSortBy(newSortBy);
    };

    useEffect(() => {
        const filteredAndSortedData = [...courseData].filter(courseDatas => {
            return (
                courseDatas.apaar_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.studentname.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.exam_attendance.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }).sort((a, b) => {
            if (sortBy.direction === 'asc') {
                return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
            } else {
                return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
            }
        });


        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

        setfilteredAndSortedData(paginatedData);
        setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
        setTotal(filteredAndSortedData.length);

    }, [searchQuery, sortBy, courseData, currentPage]);


    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
    };


    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    /* CUSTOME DATA TABLE END HERE */


    // console.log(Name,selectedCourse);

    return (
        <>
            <ToastContainer />
            <Template>

                {loading ? (


                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                        <div className="containeranimate">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (


                    <div className="container-fluid" >

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="col-md-12">
                                        <div className="card-header">
                                            <div className="py-3 d-flex justify-content-between align-items-center ">
                                                <h5>Course Bundle Details</h5>
                                                {/* <div className="mb-3 text-end">
                                                    <button
                                                        className="btn desp-btn"
                                                        onClick={handleDispatchHistory}
                                                    >
                                                      <i class="bi bi-clipboard2-data-fill"></i>

                                                    </button>
                                                </div> */}

                                            </div>

                                        </div>
                                        <div className="card-body ">
                                            <div className="card-body pdg">
                                                {/* <div className="table-responsive"> */}
                                                <div className="form theme-form">
                                                    <div className="card-body custom-input">


                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <label>Examination <span className="errorclr">*</span></label>

                                                                <Select
                                                                    styles={customStyles}
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="exam_id"
                                                                    name="exam_id"
                                                                    className="basic-select"
                                                                    classNamePrefix="select"

                                                                    options={getexamData.map(exam => ({
                                                                        value: exam.examid,
                                                                        label: exam.examtitle
                                                                    }))}

                                                                    onChange={handlExamChange}
                                                                    placeholder="Select an exam..."

                                                                    value={getexamData
                                                                        .filter(exam => exam.examid === examid ? examid : '')
                                                                        .map(exam => ({
                                                                            value: exam.examid,
                                                                            label: exam.examtitle
                                                                        }))}
                                                                />
                                                            </div>


                                                            <div className="col-md-4">
                                                                <label>Discipline<span className="errorclr">*</span></label>

                                                                <Select
                                                                    styles={disciplineStyles}
                                                                    maxMenuHeight={500}
                                                                    menuPlacement="auto"
                                                                    id="discipline_id"
                                                                    name="discipline_id"
                                                                    className="form"

                                                                    onChange={handlDisciplineChange}
                                                                    placeholder="Select an Discipline..."

                                                                    options={disciplinedata
                                                                        .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                                                        .map(discipline => ({

                                                                            value: discipline.id,
                                                                            label: discipline.discipline_name,

                                                                        }))

                                                                    }

                                                                    value={disciplinedata
                                                                        .filter(discipline =>
                                                                            discipline.id === disciplineId
                                                                        )
                                                                        .map(discipline => ({

                                                                            value: discipline.id,
                                                                            label: discipline.discipline_name,

                                                                        }))
                                                                    }



                                                                />

                                                            </div>
                                                            <div className="col-md-4">
                                                                <label>Course<span className="errorclr">*</span></label>

                                                                <Select
                                                                    styles={customStyles}
                                                                    maxMenuHeight={500}
                                                                    menuPlacement="auto"
                                                                    id="course_id"
                                                                    name="course_id"
                                                                    className="form"
                                                                    options={courseNameData.length > 0

                                                                        ? courseNameData.map(course => ({

                                                                            value: course.courseid,
                                                                            label: course.course_name,

                                                                        }))
                                                                        : [{ value: '', label: 'No courses available' }]
                                                                    }
                                                                    placeholder="Select Course"
                                                                    value={selctedforcource}

                                                                    onChange={handilecoursechange}
                                                                />



                                                            </div>



                                                        </div>

                                                        {/* count display section */}


                                                        {stat.total_courses && (
                                                            <div className="col-xxl-12 col-xl-12 box-col-12 pdg11">
                                                                <div className="row g-sm-3 height-equal-2 widget-charts">
                                                                    <div className="col-sm-4">
                                                                        <div className="card small-widget mb-sm-0">
                                                                            <div className="card-body primary"> <span className="f-light">Total courses</span>
                                                                                <div className="d-flex align-items-end gap-1">
                                                                                    <h4>{stat.total_courses}</h4>
                                                                                </div>
                                                                                <div className="bg-gradient">
                                                                                    <svg className="stroke-icon svg-fill">
                                                                                        <SchoolIcon sx={{ color: '#581f37' }} />
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-4">
                                                                        <div className="card small-widget mb-sm-0">
                                                                            <div className="card-body warning"><span className="f-light">Bundles Generated</span>
                                                                                <div className="d-flex align-items-end gap-1">
                                                                                    <h4>{stat.bundles_generated}</h4>
                                                                                </div>
                                                                                <div className="bg-gradient">
                                                                                    <svg className="stroke-icon svg-fill">
                                                                                        <SchoolIcon sx={{ color: '#581f37' }} />
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-sm-4">
                                                                        <div className="card small-widget mb-sm-0">
                                                                            <div className="card-body secondary"><span className="f-light">Bundles Pending</span>
                                                                                <div className="d-flex align-items-end gap-1">
                                                                                    <h4>{stat.bundles_pending}</h4>
                                                                                </div>
                                                                                <div className="bg-gradient">
                                                                                    <svg className="stroke-icon svg-fill">
                                                                                        <SchoolIcon sx={{ color: '#581f37' }} />
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        )}


                                                        {courseData.length > 0 && (
                                                            <div className="row p-4 m-4 ">
                                                                <div className="table-responsive">

                                                                    <table className="table table-striped  table-bordered ex-table mb-10 ">
                                                                        <thead class="table-primary">
                                                                            <tr className="col-cnt-tab-bg-clr">

                                                                                <th scope="col" width="50%" style={{ textAlign: "center", verticalAlign: "middle" }} rowSpan={2}>Course</th>
                                                                                <th scope="col" width="30%" style={{ textAlign: "center", verticalAlign: "middle" }} rowSpan={2}>Total Registered Students </th>
                                                                                <th scope="col" width="20%" style={{ textAlign: "center", verticalAlign: "middle" }} colSpan={3}>Attendance</th>
                                                                                {/* <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }} colSpan={5}>Mark Entry</th> */}
                                                                            </tr>
                                                                            <tr>
                                                                                <th style={{ textAlign: "center", verticalAlign: "middle" }}>P</th>
                                                                                <th style={{ textAlign: "center", verticalAlign: "middle" }}>A</th>
                                                                                <th style={{ textAlign: "center", verticalAlign: "middle" }}>M</th>

                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            <tr style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                <td>
                                                                                    <b>{courseName ? courseName : '--'}</b>
                                                                                </td>
                                                                                <td>{attendanceData.total_students}</td>
                                                                                <td>{attendanceData.total_present}</td>
                                                                                <td>{attendanceData.total_absent}</td>
                                                                                <td>{attendanceData.total_malpractice}</td>
                                                                            </tr>
                                                                        </tbody>

                                                                    </table>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {courseData.length > 0 && (
                                                            <div className="card mt-4">
                                                                <div className="border-bottom p-3 bg-primary">
                                                                    <h5 className="mb-0 fw-semibold text-white">📦 Bundle Status</h5>
                                                                </div>
                                                                <div className="card-body">
                                                                    {bundilestatus.length > 0 ? (
                                                                        <>
                                                                            <div className="row">
                                                                                <div className="col-md-12 mb-3 text-end">
                                                                                    {bundilestatus[0].bundle_despatch_status === 'generated' && (
                                                                                        <button
                                                                                            className="btn btn-primary"
                                                                                            onClick={handleDispatchAll}
                                                                                        >
                                                                                            🚚 Despatch All
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="row">
                                                                                {bundilestatus.map((bundle) => (
                                                                                    <div key={bundle.bundleId} className="col-md-6 ">
                                                                                        <div className="card " style={{ backgroundColor: 'azure' }}>
                                                                                            <div className="card-body py-3 px-4 position-relative">
                                                                                                {/* Status Badge */}
                                                                                                <span
                                                                                                    className="position-absolute top-0 end-0 m-3 badge rounded-pill text-white"
                                                                                                    style={{
                                                                                                        backgroundColor:
                                                                                                            bundle.bundle_despatch_status === 'generated' ||
                                                                                                                bundle.bundle_despatch_status === 'despatched' ||
                                                                                                                bundle.bundle_despatch_status === 'received'
                                                                                                                ? '#28a745'
                                                                                                                : '#ffc107',
                                                                                                        fontSize: '0.75rem'
                                                                                                    }}
                                                                                                >
                                                                                                    {bundle.bundle_despatch_status.toUpperCase()}
                                                                                                </span>

                                                                                                {/* Bundle Info */}
                                                                                                <h6 className="card-title mb-2">
                                                                                                    <b>📦 <span className="text-muted">Bundle ID:</span> {bundle.bundleId}</b>
                                                                                                </h6>

                                                                                                <p className="card-text mb-1">
                                                                                                    <b><i className="bi bi-file-earmark-text me-2 text-secondary"></i>
                                                                                                        Scripts: <strong>{bundle.script_count}</strong></b>
                                                                                                </p>

                                                                                                {/* Date Info */}
                                                                                                {bundle.bundle_despatch_status === 'generated' && (
                                                                                                    <p className="card-text mb-0">
                                                                                                        <b><i className="bi bi-calendar-check me-2 text-primary"></i>
                                                                                                            Generated: {bundle.generated_date}</b>
                                                                                                    </p>
                                                                                                )}
                                                                                                {bundle.bundle_despatch_status === 'despatched' && (
                                                                                                    <p className="card-text mb-0">
                                                                                                        <i className="bi bi-truck me-2 text-warning"></i>
                                                                                                        <strong>Despatched:</strong> {bundle.despatched_date}
                                                                                                    </p>
                                                                                                )}
                                                                                                {bundle.bundle_despatch_status === 'received' && (
                                                                                                    <p className="card-text mb-0">
                                                                                                        <i className="bi bi-box-arrow-in-down me-2 text-success"></i>
                                                                                                        <strong>Received:</strong> {bundle.received_date}
                                                                                                    </p>
                                                                                                )}

                                                                                                <p className="card-text mb-1">

                                                                                                    {Name.filter((name) => name.id === selectedCourse).map((name) => name.course_name)}
                                                                                                </p>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <div className="row">
                                                                            <div className="col-md-12 mb-3">
                                                                                <div className="border rounded p-3 h-100">
                                                                                    <div className="text-center fw-bold">No Bundle Found</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}


                                                        {/* CUSTOME DATA TABLE BEGAINS HERE */}


                                                        {courseData.length > 0 && (
                                                            <div className="card-body">
                                                                <div className="card-body pdg1">
                                                                    <div className="table-responsive ovrflw">
                                                                        <div className='row'>
                                                                            <div className='col-md-6 wdt' >
                                                                                <p>
                                                                                    Showing {(currentPage - 1) * 50 + 1}{''}-
                                                                                    {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                                                                </p>
                                                                            </div>
                                                                            <div className='col-md-6 wdt' align='right'>
                                                                                <input
                                                                                    type="text"
                                                                                    value={searchQuery}
                                                                                    onChange={handleSearchInputChange}
                                                                                    placeholder="Search..."
                                                                                    className='form-control'
                                                                                /></div></div>
                                                                        <table className="display dataTable table-striped table-bordered ex-v-table" ref={tableRef}>
                                                                            <thead>
                                                                                <tr className="bg-primary">
                                                                                    <th onClick={() => handleSort('apaar_no')} style={{ textAlign: "center", verticalAlign: "middle" }}>Sl No &nbsp;
                                                                                        {renderSortIcon('apaar_no')} </th>
                                                                                    <th onClick={() => handleSort('apaar_no')} style={{ textAlign: "center", verticalAlign: "middle" }} >Apaar No &nbsp;
                                                                                        {renderSortIcon('apaar_no')}</th>
                                                                                    <th onClick={() => handleSort('studentname')} style={{ textAlign: "center", verticalAlign: "middle" }} >Student Name &nbsp;
                                                                                        {renderSortIcon('studentname')}</th>
                                                                                    <th onClick={() => handleSort('exam_attendance')} style={{ textAlign: "center", verticalAlign: "middle" }} >Exam Attendance &nbsp;
                                                                                        {renderSortIcon('exam_attendance')}</th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {filteredAndSortedData.map((item, index) => {

                                                                                    const serialNumber = (currentPage - 1) * 50 + index + 1;

                                                                                    return (
                                                                                        <tr key={item.apaar_no}>
                                                                                            <td>{serialNumber}</td>

                                                                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.apaar_no}</td>
                                                                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.studentname}</td>

                                                                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                                {item.exam_attendance === "A" ? <span className="badge rounded-pill bg-danger">ABSENT</span> : item.exam_attendance === "M" ? <span className="badge rounded-pill  bg-danger">MALPRACTICE</span> : <span className="badge rounded-pill bg-success">PRESENT</span>}
                                                                                            </td>





                                                                                        </tr>
                                                                                    );

                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    {/* //pagination logic  */}

                                                                    {totalPages > 1 && (
                                                                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                                            <ul className="pagination justify-content-center">
                                                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                                    <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                                                                </li>
                                                                                <li className={`page-item`}>
                                                                                    <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                                                </li>
                                                                                {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                                {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                                                    <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                                                    </li>
                                                                                ))}
                                                                                {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                                                                <li className={`page-item`}>
                                                                                    <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                                                </li>

                                                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                                    <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                                                                </li>
                                                                            </ul>
                                                                        </nav>
                                                                    )}



                                                                </div>
                                                            </div>

                                                        )}

                                                        {/* CUSTOME DATA TABLE END HERE */}


                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


            </Template>
        </>
    );
}
